import type { SummeryTranslations } from "@/service/translate/summery/SummeryTranslations.types"
import { getCgvLink } from "@/service/legalLinks/legalLinksService"

const cgvUrl = getCgvLink()

const SummeryFrTranslations: SummeryTranslations = {
    "summery": {
        "title": "Détail de ma commande",
        "included": "inclus",
        "confirmationSummaryDetails": "Détails de ma commande",
        "samePrice": "Le même prix"
    },
    "traveller": {
        "adult": "adulte",
        "adult_plural": "adultes",
        "child": "enfant",
        "child_plural": "enfants"
    },
    "tripSummery": {
        "title": "Votre voyage",
        "destination": "Destination",
        "dates": "Dates",
        "participants": "Participants",
        "origin": "Départ de",
        "destinationStation": "Gare de destination",
        "package": "Forfait",
        "journey": "Trajet"
    },
    "packageSummery": {
        "title": "Forfait",
        "hsTitle": "Votre hébergement",
        "stay": "Séjour",
        "flight": "Vol",
        "train": "Train",
        "transfers": "Transferts",
        "skiPass": "Forfait de ski",
        "equipment": "Équipement",
        "accomodation": "Détails de l'hébergement",
        "noskipass": "Skipass retiré du package",
        "noequipment": "Matériel de ski retiré du package",
        "valleyNight": "Retour le samedi soir à la vallée"
    },
    "extrasSummery": {
        "title": "Extras",
        "titleCSE": "Vos services"
    },
    "priceSummery": {
        "fee": "Frais de réservation",
        "total": "Total",
        "perPerson": "Par personne",
        "payableNow": "À payer maintenant",
        "payableLater": "À payer plus tard",
        "lastMinuteDiscount": "Vente sur place"
    },
    "paymentCondition": {
        "fix": "Fixe",
        "flex": "Flex",
        "fixLong": "<b>Le meilleur prix</b>",
        "flexLong": "<b>La flexibilité</b>",
        "fixDescription": `Non remboursable. Paiement total à la commande. Modification des prestations hors hébergements selon les <a href="${cgvUrl}" target="_blank">conditions générales de vente.</a>`,
        "flexDescription": `Annulation et modification possible jusqu'au cancellation_until, selon les <a href="${cgvUrl}" target="_blank">conditions générales de vente.</a>`,
        // Train-only
        "trainOnlyDescription": `Annulation et modification selon les <a href="${cgvUrl}" target="_blank" rel="noopener">conditions générales de vente</a>.`
    },
    "bestPrice": {
        "title": "Meilleur prix garanti",
        "description": "En réservant avec Travelski, vous bénéficiez de la garantie du meilleur prix."
    },
    "transferSummery": {
        "title": "Transferts",
        "description": "Transfert privé vers et depuis la station",
        "funicularDescription": "Transfert A/R en funiculaire"
    },
    "familyService": {
        "3": "Skipass",
        "4": "Services Hôteliers",
        "5": "Panier de courses livré",
        "6": "Assurance",
        "7": "Vos Prestations",
        "8": "Transports",
        "11": "Restauration",
        "12": "Ecole de Ski - Cours collectifs",
        "13": "Activités Bien Etre",
        "14": "Matériel de ski",
        "30": "Casque",
        "38": "Offre spéciale",
        "40": "Activités Après-Ski",
        "41": "Sport",
        "42": "Parc d'attractions",
        "44": "-",
        "53": "Matériel de ski",
        "54": "Matériel de ski",
        "55": "Matériel de ski",
        "56": "Matériel de ski",
        "57": "Matériel de ski",
        "63": "Matériel de ski",
        "64": "Ecole de Ski - Cours collectifs",
        "65": "Pass Multi-activités",
        "66": "Parc à thème",
        "67": "Bagagerie",
        "68": "Animations & Evénement",
        "69": "Parking",
        "70": "Taxe de séjour",
        "71": "Vente sur place",
        "72": "Activités Vélo",
        "73": "Activités Eaux vives",
        "74": "Activités Grand-air & Rando",
        "75": "Skipass famille",
        "77": "Sensations fortes et adrénaline",
        "78": "Transferts",
        "81": "Vol",
        "82": "Bagage",
        "83": "Transport",
        "84": "Petit déjeuner"
    },
    "priceUpdatedSummery": {
        "priceUpdated": "Prix mis à jour le",
        "priceUpdatedDescription": "Le prix de votre commande peut changer en fonction de l'offre disponible en temps réel de nos fournisseurs."
    }
}

export default SummeryFrTranslations;